
import React from 'react';
import { LayoutDashboard } from 'lucide-react';
import { SimulationConfig } from '@/types';

interface UIReopenButtonProps {
  showUI: boolean;
  setShowUI: (show: boolean) => void;
  config: SimulationConfig;
}

export const UIReopenButton: React.FC<UIReopenButtonProps> = ({ showUI, setShowUI, config }) => {
  if (showUI) return null;

  return (
    <div className="absolute top-1/2 right-0 -translate-y-1/2 z-[45]">
      <button
        onClick={() => setShowUI(true)}
        className={`flex items-center justify-center w-14 h-24 rounded-l-[2rem] border-y border-l transition-all animate-in slide-in-from-right duration-500 hover:w-20 group ${
          config.darkMode 
            ? 'bg-zinc-900 border-white/10 text-cyan-400 hover:bg-zinc-800 shadow-[0_0_20px_rgba(0,0,0,0.5)]' 
            : 'bg-white border-zinc-200 text-cyan-600 hover:bg-zinc-50 shadow-[0_0_20px_rgba(0,0,0,0.1)]'
        }`}
      >
        <div className={`p-2 rounded-xl transition-all group-hover:scale-110 ${config.darkMode ? 'bg-cyan-500/10' : 'bg-cyan-50'}`}>
          <LayoutDashboard className="w-6 h-6" />
        </div>
      </button>
    </div>
  );
};
